// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../css-loader/index.js??ref--6-2!./vue-cool-lightbox.min.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../vue-style-loader/lib/addStylesClient.js").default
var update = add("59de9796", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-cool-lightbox/dist/vue-cool-lightbox.min.css
// module id = 760
// module chunks = 20 23